import React, { useRef } from 'react'
import { Dropdown, Popconfirm, Skeleton } from 'antd'
import { PageHeader as PageHeaderAntd } from '@ant-design/pro-layout'
// import PropTypes from 'prop-types'
import { darkModeSelector } from 'app-redux/selectors'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { MoreOutlined } from '@ant-design/icons'
import styles from './index.module.scss'

const normalizeExtra = (extra) => {
  if (Array.isArray(extra)) {
    return { primary: extra, more: [] }
  }

  return {
    primary: extra?.primary || [],
    more: extra?.more || [],
  }
}

function PageHeader({
  style = { padding: 0, marginBottom: 30 },
  loading = false,
  titleClassName,
  extraClassName,
  className,
  moreTrigger = ['click'],
  moreOpen,
  onMoreOpenChange,
  confirm,
  extraId,
  ...props
}) {
  const darkMode = useSelector(darkModeSelector)
  const moreRef = useRef(null)

  const { primary, more } = normalizeExtra(props.extra)

  const newExtra = props.extra ? (
    <div className={cn(styles.page_header_extra, extraClassName)}>
      <div className={styles.primary_actions}>
        {primary.map((e, i) => (
          <div key={e?.key ?? `primary-${i}`}>{e}</div>
        ))}
      </div>

      {more.length > 0 && (
        <div ref={moreRef} className={styles.more_actions}>
          <Dropdown
            menu={{ items: more }}
            trigger={moreTrigger}
            open={moreOpen}
            onOpenChange={onMoreOpenChange}
          >
            <MoreOutlined id={extraId} className={styles.more_icon} />
          </Dropdown>

          {confirm?.open && (
            <Popconfirm
              title={confirm.title}
              open={confirm.open}
              onConfirm={confirm.onConfirm}
              onCancel={confirm.onCancel}
              placement="bottomLeft"
              getPopupContainer={() => moreRef.current}
              okButtonProps={confirm.okButtonProps}
            >
              <span />
            </Popconfirm>
          )}
        </div>
      )}
    </div>
  ) : null

  return (
    <PageHeaderAntd
      style={style}
      className={cn(className)}
      {...props}
      title={
        loading ? (
          <Skeleton.Input style={{ width: 300 }} active />
        ) : (
          <div
            className={cn('page-header-title', titleClassName)}
            style={{ color: darkMode ? '#DCDCDC' : '#000' }}
          >
            {props.title}
          </div>
        )
      }
      extra={newExtra}
    />
  )
}

// PageHeader.propTypes = {
//   style: PropTypes.object,
//   loading: PropTypes.bool,
// }

// PageHeader.defaultProps = {
//   style: { padding: 0, marginBottom: 30 },
//   loading: false,
// }

export default PageHeader
